const access = [
  {
    path: '/accounting/settings',
    name: 'accounting_settings',
    component: () => import('@/views/accounting/AccountingSetting.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_accounting',
      resource: 'all',
    },
  },
  {
    path: '/accounting/financial_year',
    name: 'accounting_financial_year',
    component: () => import('@/views/accounting/AccountingYear.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_accounting',
      resource: 'all',
    },
  },
  {
    path: '/accounting/products',
    name: 'accounting_products',
    component: () => import('@/views/accounting/RegisterProducts.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_accounting',
      resource: 'all',
    },
  },
  {
    path: '/accounting/contacts',
    name: 'accounting_contacts',
    component: () => import('@/views/accounting/AccountingContact.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_accounting',
      resource: 'all',
    },
  },
  {
    path: '/accounting/banks',
    name: 'accounting_banks',
    component: () => import('@/views/accounting/AccountingBank.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_accounting',
      resource: 'all',
    },
  },
  {
    path: '/accounting/sync',
    name: 'accounting_sync',
    component: () => import('@/views/accounting/AccountingSync.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_accounting',
      resource: 'all',
    },
  },
]

export default access
